// Unpublished Work © 2026 Deere & Company.
import React from 'react';
import {Link} from '@deere/isg.component-library';

export const SocialLinks = ({links}: {links: Record<string, string>[]}) => {
    return (
        <div className='flex flex-wrap flex-row items-center justify-center gap-x-6 gap-y-2 h-6 p-0'>
            {links.map((link, index) => (
                <Link
                    href={link.url}
                    key={`${link.iconText}-${index}`}
                    style={{
                        display: 'inline-block',
                        width: 24,
                        height: 24,
                        background: `url("${link.icon}")`
                    }}
                />
            ))}
        </div>
    );
};
